var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "leaderboard container",
    attrs: {
      "id": "million-bit-leaderboard"
    }
  }, [_c('h1', {
    staticClass: "pt-3 honk-text"
  }, [_vm._v("Leaderboard")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group btn-block"
  }, [_c('button', {
    staticClass: "btn btn-icon btn-block btn-primary my-3",
    class: {
      'disabled': _vm.leaderboardView === 'pixels'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleView()
      }
    }
  }, [_vm._v("\n          Pixels\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-icon btn-block btn-primary my-3",
    class: {
      'disabled': _vm.leaderboardView === 'clicks'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleView()
      }
    }
  }, [_vm._v("\n          Clicks\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "leaderboard-wrap mb-5"
  }, [(_vm.leaderboardView === 'pixels') ? _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.teams), function(team) {
    return _c('tr', {
      key: team._id
    }, [_c('td', [_c('h2', {
      staticClass: "mr-1 honk-text"
    }, [_vm._v(_vm._s(team.rank))])]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_c('h4', {
      domProps: {
        "textContent": _vm._s(team.team.name)
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, _vm._l((team.seqs), function(seq) {
      return _c('span', {
        key: seq.hash
      }, [_c('a', {
        directives: [{
          name: "lazy-load",
          rawName: "v-lazy-load"
        }],
        attrs: {
          "href": seq.url,
          "target": "_blank"
        }
      }, [_c('img', {
        attrs: {
          "data-url": _vm.s3Base + seq.hash + '-crop.jpeg'
        }
      })])])
    }), 0), _vm._v(" "), _c('td', {
      staticClass: "text-right pixel-count"
    }, [_c('h5', {
      staticClass: "mr-2"
    }, [_vm._v(_vm._s(team.pixels) + " pixels")])])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.leaderboardView === 'clicks') ? _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.clicks), function(click, i) {
    return _c('tr', {
      key: click._id
    }, [_c('td', [_c('h2', {
      staticClass: "mr-1 honk-text"
    }, [_vm._v(_vm._s(i + 1))])]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_c('a', {
      directives: [{
        name: "lazy-load",
        rawName: "v-lazy-load"
      }],
      attrs: {
        "href": click.url,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "data-url": _vm.s3Base + click.hash + '-crop.jpeg'
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_c('a', {
      attrs: {
        "href": click.url,
        "target": "_blank"
      }
    }, [_vm._v("\n          " + _vm._s(click.url) + "\n        ")])])])
  }), 0) : _vm._e()])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27cb39ab","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Leaderboard.vue
// module id = iDxL
// module chunks = 2